import React, { Component } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import { b_seminars_config } from 'Shared/options';
export default class CompanyBookingRow extends Component {
  state = {
    loading: false
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-date"
    }, moment(data.created_at).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-date"
    }, moment(data.date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-login"
    }, data.customer.lastname, ' ', data.customer.firstname), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-login"
    }, data.customer.login), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-login"
    }, data.coworking_space.name), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-type"
    }, data.coworking_space.type === 'b_seminar' ? 'Meeting' + b_seminars_config[data.disposition]?.title : 'Lounge'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-amount"
    }, data.amount, " cr\xE9dits"));
    return output;
  }
}
